import { getCategoryHref } from '../../utils/common/category';
import { BUSINESS_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'businessIdeaGeneratorType',
      analyticsName: 'business_idea_type',
      textLabel: 'Generate business ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: BUSINESS_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Business',
        value: getCategoryHref(BUSINESS_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'businessIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'business_ideas_generator',
      placeholder: 'Try "global marketing agency" or "clothing shop in Amsterdam""',
      textLabel: 'Describe what kind of business you want',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: BUSINESS_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
